import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { NavLink, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import ErrorMessage from '../AppLayouts/ErrorMessage';
import Header from '../Headers/Header';

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

//Css start for signup form
const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '98%',
    },
  },
  rootBox: {
    flexGrow: 1,
  },
  paper: {
    width: '100%',
    boxShadow: 'none',
    display: 'flex'
  },
  signMain: {
    position: 'relative',
    width: '100%',
    background: 'rgba(0,0,0,.5)',    
    top: '0',
    marginTop: '-125px',
    zIndex: '1',
    '@media only screen and (max-width: 1500px)': {
      height: '140vh',
    },
    '@media only screen and (max-width: 3500px) and (min-width: 1501px)': {
      height: '120vh',
    },
    '@media only screen and (min-width: 3501px)': {
      height: '98.4vh',
    },
  },
  signInBtn: {
    border: '1px solid rgba(36, 97, 142, 1)',
    color: '#fff',
    background: 'rgba(36, 97, 142, 1)!important',    
    '@media only screen and (max-width: 3500px)': {
      fontSize: '14px',
      width: '140px',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '24pt',
      width: '180px',
      marginBottom: '10px',
    },
  },
  formLogo: {
    textAlign: 'center',
    width: '100%',
    paddingTop: '15px',
    '& p': {
      textAlign: 'right',
      margin: '0px 0 -20px',
      paddingRight: '15px',
      fontSize: '25px',
    },
    '& a': {
      color: '#24618E',
    }
  },
  rootForm: {    
    margin: '10px auto 0',
    border: '1px solid rgba(0, 167, 93, 1)',
    padding: '10px',
    borderRadius: '5px',
    boxShadow: '1px 4px 5px 1px #ccc',
    '@media only screen and (max-width: 3500px)': {
      width: '80%',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '85%',
    },
    '& input#email': {
      padding: '10px',
    },
    '& input#first_name': {
      padding: '10px',
    },
    '& input#last_name': {
      padding: '10px',
    },
    '& input#password': {
      padding: '10px',
    },
    '& input#confirm_password': {
      padding: '10px',
    },
    '& h3': {
      color: '#24618E',      
      marginTop: '0px',
      marginBottom: '0',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '20px',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '26pt',
      },
    },
    '& h4': {
      margin: '0px',
      '@media only screen and (min-width: 3501px)': {
        fontSize: '24pt',
      },
    },
    '& ul': {
      marginTop: '5px',
      paddingLeft: '25px',
    }
  },
  formInput: {
    width: '100%',
  },
  OtherLink: {
    width: '80%',
    margin: '0 auto',
    '& a': {
      color: '#24618E',
    }
  },
  errIcon: {
    fontSize: '26px',
    color: '#CC0000',
    margin: '2%'
  },
  errorInput: {
    width: '100%',
    backgroundColor: '#F2DEDE',
    border: '1px solid #CC0000'
  },
  errMsgSignUp: {
    '& span': {
      fontSize: '11pt !important'
    }
  },
  userFormContainer: {
    '@media only screen and (max-width: 3500px)': {
      width: '500px',
      paddingTop: '90px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '650px',
      maxWidth: '650px',
      paddingTop: '250px',
      '& input': {
        fontSize: '22pt',
      }
    },
  },
  closeIcon: {
    '&:hover': {
      color: '#CC0000',
    }
  },
  formIcon:{
    '@media only screen and (max-width: 3500px)': {
      width: '215px', 
      height:'50px'
    },
    '@media only screen and (min-width: 3501px)': {
      width: '300px', 
      height:'70px'
    },
  }
}));
//Css end for signup form

//Start Signup component code ...
export default function Signup() {
  let history = useHistory();
  const [spacing, setSpacing] = React.useState(2);
  const [errPopUp, setErrPopUp] = React.useState(false);
  const [errMsg, setErrMsg] = React.useState(null);
  const [errEmail, setErrEmail] = React.useState(null);
  const [errPassword, setErrPassword] = React.useState(null);
  const [errFirstName, setErrFirstName] = React.useState(null);
  const [errLasttName, setErrLastName] = React.useState(null);
  const [errConfirmPassword, setErrConfirmPassword] = React.useState(null);
  const [errMsgType, setErrMsgType] = React.useState('error');
  const [values, setValues] = React.useState({
    first_name: "",
    last_name: "",
    email: "",
    pwd: "",
    cnfPwd: "",
    createdby_userid: 0,
    organization: "",
    subdomain: window.location.hostname
  });
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const classes = useStyles();

  const handleChange = name => event => {
    if (name == 'first_name') {
      setFirstName(event.target.value);
    } else if (name == 'last_name') {
      setLastName(event.target.value);
    } else if (name == 'email') {
      setEmail(event.target.value);
    } else if (name == 'pwd') {
      setPassword(event.target.value);
    } else if (name == 'cnfPwd') {
      setConfirmPassword(event.target.value);
    }
    setErrEmail(false);
    setErrFirstName(false);
    setErrLastName(false);
    setErrPassword(false);
    setErrConfirmPassword(false);
    setValues({ ...values, [name]: event.target.value });    
  }
  const ShowErrPopUP = () => {
    setErrPopUp(false)
  };

  //This method is use for form validations start ...
  const validateForm = async e => {
    setErrMsg(null)   
    let checkEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let passwordCheck = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$.!%*?&]{8,}$/
    e.preventDefault()
    if (values.first_name == '' &&
      values.last_name == '' &&
      values.email == '' &&
      values.pwd == '') {
      setErrEmail(true);
      setErrFirstName(true);
      setErrLastName(true);
      setErrPassword(true);
      setErrConfirmPassword(true);
      setErrMsgType('error');
      setErrMsg('All Fields Required');
      setErrPopUp(true);
    } else if (values.first_name == '') {
      setErrFirstName(true);
      setErrMsgType('error');
      setErrMsg('First Name Required');
      setErrPopUp(true);
    } else if (values.last_name == '') {
      setErrLastName(true);
      setErrMsgType('error');
      setErrMsg('Last Name Required');
      setErrPopUp(true);
    } else if (values.email == '') {
      setErrEmail(true);
      setErrMsgType('error');
      setErrMsg('E-mail Required');
      setErrPopUp(true);
    } else if (!checkEmail.test(values.email)) {
      setErrEmail(true);
      setErrMsgType('error');
      setErrMsg('Email format must be like yourname@example.com');
      setErrPopUp(true);
    } else if (values.pwd == '') {
      setErrPassword(true);
      setErrMsgType('error');
      setErrMsg('Password Required');
      setErrPopUp(true);
    } else if (!passwordCheck.test(values.pwd)) {
      setErrPassword(true);
      setErrMsgType('error');
      setErrMsg('Password does not meet the criterion.');
      setErrPopUp(true)
    } else if (values.pwd.includes(values.email)) {
      setErrPassword(true);
      setErrMsgType('error');
      setErrMsg('Password must not contain your email.');
      setErrPopUp(true);
    } else if ((values.pwd).toLowerCase().includes((values.first_name).toLowerCase()) && (values.pwd).toLowerCase().includes((values.last_name).toLowerCase())) {
      setErrPassword(true);
      setErrMsgType('error')
      setErrMsg('Password not contain your name.');
      setErrPopUp(true);
    } else if (values.pwd !== values.cnfPwd) {
      setErrConfirmPassword(true);
      setErrMsgType('error');
      setErrMsg('The provided passwords do not match');
      setErrPopUp(true);
    } else {
      signUpUser();
    }
  }
  //This method is use for form validations end ...
  

  //This method is use for form signup user start ...
  const signUpUser = () => {
    try {
      axios({
        method: 'post',
        data: values,
        url: API_URL + '/api/v1/user/signup',
      })
        .then(function (response) {
          if (response.status && response.status == '200') {
            setErrMsgType('success');
            setErrMsg('A verification link has been sent to the email you provided. Please verify and login.');
            setErrPopUp(true);
            setFirstName('');
            setLastName('');
            setEmail('');
            setPassword('');
            setConfirmPassword('');
          } else {
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true)
          }
        }).catch(function (error) {
          if (error.response) {
            setErrMsgType('error')
            setErrMsg(error.response.data.message.message);
            setErrPopUp(true)
          } else {
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true)
          }
        })
    } catch (error) {
      console.error(error);
    }
  }
  //This method is use for form signup user end ...

  return (
    <React.Fragment>
      <Header />
      <CssBaseline />
      <div className={classes.signMain}>
        <Container maxWidth="sm" className={classes.userFormContainer}>
          <Typography component="div" style={{ backgroundColor: '#fff', minHeight: '360px', paddingBottom: '10px', position: 'relative', border: '1px solid #24618E', borderRadius: '5px', }}>
            <div className={classes.formLogo}>
              <p><NavLink className={classes.closeIcon} to="/" title='Close'><FontAwesomeIcon icon={faTimes}  title='Close'/></NavLink></p>
              <img src={require('../../assets/images/dataPointMainLogo.svg')} className={classes.formIcon}></img>
            </div>
            {errMsg ? <div className={classes.errMsgSignUp} ><ErrorMessage message={errMsg} visible={ShowErrPopUP} show={errPopUp} msgType={errMsgType} /> </div> : null}
            <form className={classes.rootForm} noValidate autoComplete="off" onSubmit={e => validateForm(e)}>
              <h3>Sign Up for an Account</h3>
              <img src={require('../../assets/images/hrimg.svg')} style={{ marginBottom: '10px',width: '100%', height: '1px' }} />
              <Grid container className={classes.rootBox} spacing={spacing}>
                <Grid item xs={12}>
                  <Grid container justify="center" spacing={spacing}>
                    <Grid xs={6} item>
                      <Paper className={classes.paper} >
                        <TextField id="first_name" data-testid="first_name" className={errFirstName ? classes.errorInput : classes.formInput} placeholder="First Name *" type="text" variant="outlined" required onChange={handleChange('first_name')} value={firstName} />
                        {errFirstName ? <FontAwesomeIcon icon={faExclamationCircle} className={classes.errIcon} /> : null}
                      </Paper>
                    </Grid>
                    <Grid xs={6} item>
                      <Paper className={classes.paper} >
                        <TextField id="last_name" data-testid="last_name" className={errLasttName ? classes.errorInput : classes.formInput} placeholder="Last Name *" type="text" variant="outlined" required onChange={handleChange('last_name')} value={lastName} />
                        {errLasttName ? <FontAwesomeIcon icon={faExclamationCircle} className={classes.errIcon} /> : null}
                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} >
                        <TextField id="email" data-testid="email" className={errEmail ? classes.errorInput : classes.formInput} placeholder="Email *" type="email" variant="outlined" required onChange={handleChange('email')} value={email} />
                        {errEmail ? <FontAwesomeIcon icon={faExclamationCircle} className={classes.errIcon} /> : null}
                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} >
                        <TextField id="password" data-testid="password" className={errPassword ? classes.errorInput : classes.formInput} placeholder="Password *" type="password" variant="outlined" required onChange={handleChange('pwd')} value={password} />
                        {errPassword ? <FontAwesomeIcon icon={faExclamationCircle} className={classes.errIcon} /> : null}
                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} >
                        <TextField id="confirm_password" data-testid="confirm_password" className={errConfirmPassword ? classes.errorInput : classes.formInput} placeholder="Confirm Password *" type="password" variant="outlined" required onChange={handleChange('cnfPwd')} value={confirmPassword} />
                        {errConfirmPassword ? <FontAwesomeIcon icon={faExclamationCircle} className={classes.errIcon} /> : null}
                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} >
                        <h4>Password should:</h4>
                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} >
                        <ul>
                          <li>be at least 8 characters long</li>
                          <li>contain at least 1 number, 1 upper-case letter, and 1 lower-case letter</li>
                          <li>contain at least 1 special character</li>
                          <li>not contain your name or email address</li>
                        </ul>
                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} style={{ textAlign: 'center', display: 'block' }} >
                        <Button type="submit" variant="outlined" id="signUp_btn" data-testid="signUp_btn" className={classes.signInBtn}>
                          Sign Up
                </Button>
                      </Paper>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </form>
            <div className={classes.OtherLink}>
              <p style={{ marginBottom: '5px' }}><NavLink to="/forgot_password" data-testid="forgotPwdLink">Forgot your password?</NavLink></p>
              <p style={{ marginTop: '5px' }}><NavLink to="/sign_in" data-testid="signInLink">Sign In</NavLink></p>
            </div>
          </Typography>
        </Container>
      </div>
    </React.Fragment>
  );
}
//End Signup component code ...